import React, { useMemo } from "react";

import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { UserData, getUserQuery } from "./details-page";
import { ActionButtons } from "./details-page";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { deleteUserMutation } from "./table";

const UserDetailsPage = ({
  match: {
    params: { username },
  },
  location: {},
  history,
}) => {
  const { currentCustomerId, customers, contracts } = useCurrentCustomerContext();
  const query = useMemo(() => getUserQuery(username), [username]);
  const { data, loading, error } = useQuery(query);

  const userDetail = data.user;

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={userDetail}>
        <PageHeaderBar
          showBackButton
          title="app.page.user.details.title"
          titleParams={{ userName: userDetail ? userDetail.name : null }}
          buttons={
            <ActionButtons
              username={username}
              customerId={currentCustomerId}
              name={username}
              mutation={deleteUserMutation}
              history={history}
            />
          }
        />
        <PageSection>
          <UserData user={userDetail} contracts={contracts} customers={customers} />
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default UserDetailsPage;
